module.exports = __webpack_public_path__ + "static/media/inline-notification.3be9d7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notifications/inline-notification.png
// module id = 1261
// module chunks = 0